import { Component, inject, ViewEncapsulation } from '@angular/core'
import { VetSchedulePlannerService } from '../vet-schedule-planner.service'
import * as datefns from 'date-fns'
import { ToastrService } from 'ngx-toastr'

@Component({
   selector: 'vsp-inactive-doctor-list-dialog',
   standalone: false,
   templateUrl: './inactive-doctor-list-dialog.component.html',
   styleUrl: './inactive-doctor-list-dialog.component.scss',
   encapsulation: ViewEncapsulation.None,
})
export class InactiveDoctorListDialogComponent {
   service = inject(VetSchedulePlannerService)
   toastr = inject(ToastrService)
   close() {
      this.service.inactiveDoctorListDialogVisible.set(false)
   }
   addDoctor(doctor: any) {
      this.service.isLoading.set(true)
      this.service
         .saveDoctorChanges({ ...doctor, doesNotWorkHere: false, startDate: datefns.format(this.service.week().firstDay, 'yyyy-MM-dd') }, doctor)
         .subscribe({
            next: () => {
               this.close()
               this.service.reloadWeek()
            },
            error: () => {
               this.service.showError('Failed to add doctor.');
               this.service.isLoading.set(false)
            },
         })
   }
}
